export enum FurnitureType {
  ARREDATO = 'ARREDATO',
  NON_ARREDATO = 'NON_ARREDATO',
  PARZIALE = 'PARZIALE',
  CONTRATTABILE = 'CONTRATTABILE',
}
